import { render, staticRenderFns } from "./MarketMiniPanel.vue?vue&type=template&id=2917477f&"
import script from "./MarketMiniPanel.vue?vue&type=script&lang=js&"
export * from "./MarketMiniPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports